import { api } from '@/services/api'
import { getEnvValue } from '@/utils/platform'

export interface MobileFirebaseConfig {
  apiKey: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  packageName: string
}

export interface MobilePublicConfig {
  googleClientId: string
  facebookAppId: string
  firebase: MobileFirebaseConfig
}

let cachedConfig: MobilePublicConfig | null = null
let loadPromise: Promise<MobilePublicConfig | null> | null = null

function applyToRuntimeEnv(config: MobilePublicConfig) {
  const envConfig = (window as Window & { ENV_CONFIG?: Record<string, string> }).ENV_CONFIG || {}
  const next = { ...envConfig }

  if (config.googleClientId) {
    next.VITE_GOOGLE_CLIENT_ID = config.googleClientId
  }
  if (config.facebookAppId) {
    next.VITE_FACEBOOK_APP_ID = config.facebookAppId
  }

  ;(window as Window & { ENV_CONFIG?: Record<string, string> }).ENV_CONFIG = next
}

export async function loadMobilePublicConfig(): Promise<MobilePublicConfig | null> {
  if (cachedConfig) return cachedConfig
  if (loadPromise) return loadPromise

  loadPromise = (async () => {
    try {
      const { data } = await api.getMobileConfig()
      if (data.success && data.data) {
        cachedConfig = data.data
        applyToRuntimeEnv(data.data)
        return data.data
      }
    } catch (error) {
      console.warn('Failed to load mobile config from API, using build-time env:', error)
    }
    return null
  })()

  return loadPromise
}

export function getGoogleClientId(): string {
  return cachedConfig?.googleClientId || getEnvValue('VITE_GOOGLE_CLIENT_ID')
}

export function getFacebookAppId(): string {
  return cachedConfig?.facebookAppId || getEnvValue('VITE_FACEBOOK_APP_ID')
}

export function getMobileFirebaseConfig(): MobileFirebaseConfig | null {
  return cachedConfig?.firebase ?? null
}
